import {
  OrderStatus as ApiStatus,
  OrderStatusCanceled,
  OrderStatusExecuted,
  OrderStatusExpired,
  OrderStatusFailed,
  OrderStatusFilled,
  OrderStatusOpen,
  OrderStatusPartiallyFilled,
  OrderStatusPending,
  OrderStatusTriggered,
  OrderStatusUnspecified,
  OrderStatusUntriggered,
} from '@/api/spec';
import { OrderType } from '@/common/constants';

export { OrderType }; // defined in common so uiStore can use it

export type OrderDisplayType = OrderType | 'change';

export enum OrderAction {
  open = 'open',
  close = 'close',
}

export enum TiF {
  gtc = 'gtc',
  fillOrKill = 'fillOrKill',
  immediateOrCancel = 'immediateOrCancel',
  postOnly = 'postOnly',
}

export enum SLTPType {
  price = 'price',
  percent = 'percent',
}

export enum OrderStatus {
  unspecified = 'unspecified',
  pending = 'pending',
  open = 'open',
  partial = 'partial',
  filled = 'filled',
  canceled = 'canceled',
  expired = 'expired',
  failed = 'failed',
  triggered = 'triggered',
  untriggered = 'untriggered',
  executed = 'executed',
  liquidation = 'liquidation',
}

export const orderStatusMapper: Record<ApiStatus, OrderStatus> = {
  [OrderStatusUnspecified]: OrderStatus.unspecified,
  [OrderStatusPending]: OrderStatus.pending,
  [OrderStatusOpen]: OrderStatus.open,
  [OrderStatusPartiallyFilled]: OrderStatus.partial,
  [OrderStatusFilled]: OrderStatus.filled,
  [OrderStatusCanceled]: OrderStatus.canceled,
  [OrderStatusExpired]: OrderStatus.expired,
  [OrderStatusFailed]: OrderStatus.failed,
  [OrderStatusTriggered]: OrderStatus.triggered,
  [OrderStatusUntriggered]: OrderStatus.untriggered,
  [OrderStatusExecuted]: OrderStatus.executed,
};
